import React from 'react';
import { Class, Enrollment } from "@/types/classTypes";
import TabsContent from './tabs/TabsContent';
import WaitlistTestComponent from './WaitlistTestComponent';

interface ClassTabsProps {
  classData: Class;
  enrollments: Enrollment[];
  organizationId: string;
  onScheduleUpdated?: () => Promise<void>;
}

const ClassTabs: React.FC<ClassTabsProps> = ({
  classData,
  enrollments,
  organizationId,
  onScheduleUpdated
}) => {
  const handleEnrollmentUpdated = async () => {
    // This would typically refresh the enrollments list
    // This could be implemented by lifting state up or using a context/store
    window.location.reload();
  };

  // Add this for testing purposes - remove in production
  const useTestWaitlist = new URLSearchParams(window.location.search).get('test_waitlist') === 'true';

  return (
    <>
      {useTestWaitlist ? (
        <WaitlistTestComponent 
          classId={classData.id} 
          organizationId={organizationId} 
        />
      ) : (
        <TabsContent
          classData={classData}
          enrollments={enrollments}
          organizationId={organizationId}
          onScheduleUpdated={onScheduleUpdated}
          onEnrollmentUpdated={handleEnrollmentUpdated}
        />
      )}
    </>
  );
};

export default ClassTabs;
